
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import isNil from 'lodash/isNil';
import { mergeStyleSets } from '@uifabric/merge-styles';

import {
    PRICELIST_TYPE_CUSTOM, PRICELIST_TYPE_DEFAULT, PRICELIST_TYPE_EDIT_DEFAULT, PRICELIST_TYPE_FILE
} from '../../reducers/project';

const classNames = mergeStyleSets({
    label: {
        borderBottom: '1px solid #000000'
    },

    btnBox: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '1em 0em'
    }
})

const SelectPricelistTypeEnabled = ({
    pricelistType,
    onContinueClick,
    onTypeChange
}) => {

    return (
        <Stack verticalFill>
            <Stack.Item>
                <h3 className={classNames.label}>Výběr způsobu zadání ceníku prací a materiálů</h3>
            </Stack.Item>
            <Stack.Item vertical>
                <ChoiceGroup
                    selectedKey={pricelistType}
                    options={[
                        { key: PRICELIST_TYPE_DEFAULT, text: 'Použít výchozí ceník'},
                        { key: PRICELIST_TYPE_EDIT_DEFAULT, text: 'Upravit výchozí ceník'},
                        { key: PRICELIST_TYPE_CUSTOM, text: 'Vytvořit vlastník ceník'},
                        { key: PRICELIST_TYPE_FILE, text: 'Načíst ceník ze souboru'}
                    ]}
                    onChange={onTypeChange}
                    label="Vyberte způsob zadání ceníku, který chcete použít pro kalkulaci"
                />
            </Stack.Item>
            <Stack.Item className={classNames.btnBox}>
                <DefaultButton
                    iconProps={{ iconName: 'ChevronRightMed' }}
                    disabled={isNil(pricelistType)}
                    onClick={onContinueClick}
                    text="Pokračovat"
                />
            </Stack.Item>
        </Stack>
    );
}

export default SelectPricelistTypeEnabled;
